import axios from "axios";
import store from "@/store";
import {
  getAccessToken,
  getJWTPayload,
  getRefreshToken,
  setAccessToken,
} from "@/modules/common/utils/tokens";

const APIUrl =
  process.env.NODE_ENV === "dev" ? "http://localhost:8000" : process.env.VUE_APP_API_ROOT;

const axiosPublic = axios.create({
  baseURL: APIUrl,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosPrivate = axios.create({
  baseURL: APIUrl,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

function addAccessTokenToHeader(config: any, token: string | null) {
  if (token !== null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

axiosPrivate.interceptors.request.use(
  (config: any) => {
    const accessToken = getAccessToken();
    return addAccessTokenToHeader(config, accessToken);
  },
  (error: any) => Promise.reject(error),
);

axiosPrivate.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    if (error.response.status !== 401) {
      return Promise.reject(error); // ошибка, не связанная с авторизацией
    }

    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      // refresh token куда то исчез!)
      // TODO: Необходимо реализовать обработку,
      await store.dispatch("auth/SIGN_OUT");
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !config.sent) {
      config.sent = true;

      const newAccessToken = await store.dispatch("auth/FETCH_NEW_ACCESS_TOKEN", refreshToken);
      if (!newAccessToken) {
        return Promise.reject(error);
      }
      setAccessToken(newAccessToken);
      const newConfig = addAccessTokenToHeader(config, newAccessToken);
      return axios(newConfig);
    }
  },
);

export { APIUrl, axiosPublic, axiosPrivate };
